import React from 'react';
import ChevronDown from 'images/icons/controls/chevron-down.svg?react-svg';
import ChevronUp from 'images/icons/controls/chevron-up.svg?react-svg';
import { Small, SmallUppercase } from 'scy/text';
import { TextButton } from 'scy/buttons';
import { secondary } from 'scy/text/styles.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { tablet_hidden } from 'scy/display.mod.scss';
import { bottomMedium } from 'scy/border.mod.scss';
import { textCenter, textLeft } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

export default function CheckoutSummary({
  showTotal,
  total,
  collapsed,
  toggleCollapsed
}) {
  return (
    <div className={`${flex} ${tablet_hidden} ${bottomMedium} ${padding.sm}`}>
      <TextButton
        noUnderline
        className={`${flex1} ${textLeft}`}
        onClick={toggleCollapsed}
      >
        <Small tag="div">
          {collapsed ? 'Show Order Summary' : 'Hide Order Summary'}
          <span className={`${margin.left_xs} ${secondary}`}>
            {collapsed ? <ChevronDown width={8} /> : <ChevronUp width={8} />}
          </span>
        </Small>
      </TextButton>

      {showTotal && (
        <div className={textCenter}>
          <SmallUppercase tag="div">Total</SmallUppercase>
          <Small tag="div">${total}</Small>
        </div>
      )}
    </div>
  );
}
